import React, { ComponentType, lazy, Suspense } from 'react';
import { useBreakpoints } from '@ux/responsive';
import { BehaviorType } from 'core/ribbons/cta';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import Ribbon from 'components/ribbons/Ribbon';
import errorBoundary from 'presentation/hocs/errorBoundary';
import visibilitySet from 'presentation/hocs/visibilitySet';

const DesktopTiers = lazy(() => import('./Desktop'));
const MobileTiers = lazy(() => import('./Mobile'));

export type Link = {
  href?: string;
  first?: boolean;
  behavior?: BehaviorType;
};

export interface OuterProps extends RibbonProps {
  selected: number;
  links?: Array<Link>;
}

export const PureTiers = ({ loading, colorway, layout, name, links = [], ...props }: OuterProps) => {
  const { isMinSm } = useBreakpoints();
  const Tiers = isMinSm ? DesktopTiers : MobileTiers;

  return (
    <Ribbon
      id={props.id}
      layout={layout}
      colorway={colorway}
      flush={true}
      loading={loading}
      name={name}
      type={Type.TIERS}
    >
      <Suspense fallback={<div />}>
        <Tiers colorway={colorway} layout={layout} links={links} {...props} />
      </Suspense>
    </Ribbon>
  );
};

PureTiers.displayName = 'Tiers';

export default errorBoundary(visibilitySet(PureTiers)) as ComponentType<OuterProps>;
